import React, { useState } from "react";
import { PermissionGroup, Relative } from "./types";
import useSWR from "swr";
import Loader from "components/Loader";
import FormCheckbox from "@form/FormCheckbox";
import { Form } from "@form/Form";
import { useApi } from "../../../hooks/useApi";
import FormSubmit from "@form/FormSubmit";

interface Props {
    clubSlug: string;
    relative: Relative;
    callback?: () => void;
}

export const PermissionGroupAssignmentForm: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({ relative, clubSlug, callback }) => {
    const api = useApi();
    const [isLoading, setIsLoading] = useState(false);
    const { data, isLoading: isLoadingGroups } = useSWR<{ data: PermissionGroup[] }>(
        `club/${clubSlug}/permissionGroup`
    );

    const handleSubmit = (data) => {
        setIsLoading(true);
        return api({
            url: `club/${clubSlug}/permissionGroup/${relative.id}/assign`,
            method: "PUT",
            data: {
                groups: Object.entries(data)
                    .filter(([, value]) => value === true)
                    .map(([key]) => key),
            },
            onBefore: () => setIsLoading(false),
            onSuccess: callback,
        });
    };

    return (
        <Loader isLoading={isLoadingGroups}>
            <Form
                onSubmit={handleSubmit}
                defaultValues={relative.groups.reduce((carry, group) => ({ ...carry, [group.id]: true }), {})}
            >
                <div className="tw-flex tw-flex-col">
                    {data?.data.map((group) => (
                        <FormCheckbox key={group.id} name={String(group.id)}>
                            {group.title}
                        </FormCheckbox>
                    ))}
                </div>
                <FormSubmit isLoading={isLoading} />
            </Form>
        </Loader>
    );
};
